export const terminalFields = {
    KOJA: [
        "KOJA",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor DO",
        "DO Charges",
        "Materai",
        "Penumpukan",
        "DENDA SPPB",
        "DENDA SP2",
        "Monitoring",
        "Recooling",
        "Lift on",
        "Pass Pelabuhan",

        "Biaya Eticket",

        "Administrasi Nota",
        "Gate Pass Administration",
        "Pass Truck // NPCT1 Yard",
        "Storage Import Day 2",
        "Biaya Administrasi",
        "REPAIR",
        "ADMINISTRASI FEE",
        "DETERGENT WASHING",
        "LIFT OFF",
        "Survey Fee",
        "DEMURRAGE",
        "Penumpukan Masa I",
        "Penumpukan Masa II",
        "Penumpukan Masa III",
        "Administrasi OB & IT",
        "Paket PLP",
        "PNPK 20 FCL REEFER",
        "RECOOLING 20 FCL REEFER",
        "MONITORING 20 FCL REEFER",
        "LIFT ON 20 FCL REEFER",

        "PASS TRUCK",
        "Administrasi Kartu",
        "Paket Pelayanan Tambahan",
        "PNPK 40 FCL DRY",
        "LIFT ON 40 FCL DRY",
        "Pd Kjsm Pelabuhan",
        "Pd Lap - LOLO",
    ],
    NPCT: [
        "NCT1",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor BL",
        "BL Charges",
        "Materai",
        "Cost Recovery",
        "Gate Pass Administration",
        "Lift On",
        "Pass Truck // NPCT1 Yard",
        "Reefer Monitoring",
        "Reefer Plug In/Out",
        "Storage Import Day 2",
        "Storage Import Day 3",
        "Storage Import Day > 4",
        "Biaya Administrasi",
        "Gate Pass Administration",
        "Biaya Administrasi",
        "PENUMPUKAN MASA 1.2",
        "PENUMPUKAN MASA 2",
        "LIFT ON",
        "LIFT OFF",
        "PAKET PLP",
        "BIAYA KEBERSIHAN",
        "PASS TRUCK",
        "Administrasi",
        "Biaya Repair",
        "ADM REPAIR",
        "DEMURRAGE COLLECTION",
        "PNPK 40 FCL DRY",
        "Administrasi Nota",
        "Administrasi Kartu",
        "LIFT ON 40 FCL DRY",
        "TAMB. SPPB MASA II",
        "TAMB. SP2 MASA II",
        "Additional Service Activity",
    ],
    TPK1: [
        "TPK1",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor BL",
        "BL Charges",
        "Materai",
        "PNPK 20 FCL DRY",
        "PNPK 40 FCL DRY",
        "TBHN/Pinalti SPPB 20 FCL",
        "TBHN/Pinalti SPPB 40 FCL",
        "Lift On 20 FCL DRY",
        "Lift On 40 FCL DRY",
        "Pass Truck",
        "Cost Rec/Surcharge",
        "RECOOLING 20 FCL",
        "MONITORING 20 FCL",
        "Administrasi Nota",
        "Administrasi Kartu",
        "PNPK 40 FCL REEFER",
        "PNPK 20 FCL REEFER",
        "Lift On 40 FCL REEFER",
        "Lift On 20 FCL REEFER",
        "Pass Truck",
        "Administrasi Nota",
        "Administrasi Kartu",
        "PNPK 20 FCL DRY",
        "LIFT ON 20 FCL DRY",
        "RECOOLING 40 FCL",
        "MONITORING 40 FCL",
        "TBHN/PINALTI SP2 20 FCL REEFER",
        "TBHN/PINALTI SP2 40 FCL REEFER",
        "REPAIR",
        "ADMINISTRASI FEE",
        "TBHN/Pinalti SPPB 20 FCL",
        "TBHN/PINALTI SP2 20 FCL",
        "TBHN/PINALTI SP2 40 FCL",
        "TERMINAL STORAGE PHASE 2 FL40",
        "TERMINAL STORAGE PHASE 3 FL40",
        "STORAGE PHASE 3 FL40",
        "Lift Off Full FL40 Dry",
        "PAKET OB FL 40 DRY",
        "DO CHARGES",
        "Pd Adm - CCC",
        "Pd Tumpuk - CCC",
        "Pd Lolo - CCC",

        "TBHN/PINALTI SP2 20 FCL DRY",
        "RECOOLING 20 FCL REEFER",
        "MONITORING 20 FCL REEFER",
        "PAKET PELAYANAN TAMBAHAN",
        "STORAGE",
        "MEKANIK",
        "HANDLING",
        "BIAYA TPS",
    ],
    TMAL: [
        "TMAL",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor DO",
        "DO Charges",
        "Materai",
        "Cost Recovery",
        "Lift On",

        "Penumpukan Masa I-1",

        "Penumpukan Masa II",
        "Administrasi Nota",
        "Administrasi Petikemas",
        "Tambahan SPPB Masa 2",
        "Gate Pass Administration",
        "Lift On",
        "Pass Truck",
        "Storage Import Day 2",
        "Storage Import Day 3",
        "Biaya Administrasi",
        "Surcharge Repair",
        "Reefer",
        "Monitoring",
        "REPAIR",
        "Reefer",
    ],
    TER3: [
        "TER3",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor REQUEST",
        "REQUEST Charges",
        "Materai",
        "Kebersihan",
        "Lift On",
        "Penumpukan Masa I-1",
        "Penumpukan Masa I.2",
        "Penumpukan Masa II",
        "Cost Recovery",
        "Administrasi",
        "Tamb. SPPB Masa II",
        "Monitoring dan Listrik",
        "REPAIR",
        "ADMINISTRASI FEE",
        "Tamb. SP2 Masa II",
        "Pd Kjsm Pelabuhan",
        "Pd Lap-Tumpuk PK (I)",
        "Pd Kpl-LOLO (I)",
        "PNPK 40 FCL DRY 1",
        "LIFT ON 40 FCL DRY",
        "PASS TRUCK",
        "Administrasi Nota",
        "Administrasi Kartu",
        "DO CHARGES",
        "Pd Lap-Reefer (I)",
    ],
    PESA: [
        "PESA",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor",
        "Charges",
        "Materai",
        "CLEANING",
        "ADM TAX",
        "MASA",
        "PMK",
        "SURVEYOR",
        "ADM",
        "LIFT ON",
        "LIFT OFF",
        "PLP",
        "MAINTENANCE ECON TERMINAL",
        "GATE PASS",
        "MASA I-1 NCT1 CONTAINER",
        "MASA I-2 NCT1 CONTAINER",
        "MASA II-1 NCT1 CONTAINER",
        "MASA II-2 NCT1 CONTAINER",
        "TRUCK PASS",
        "MASA I-2 TPS CONTAINER",
        "MASA II-1 TPS CONTAINER",
        "LIFT ON NCT1 CONTAINER",
        "LIFT ON TPS CONTAINER",
        "LIFT OFF TPS CONTAINER",
        "ADMINISTRASI",
    ],
    CIMP: [
        "CIMP",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor",
        "Charges",
        "Materai",
        "PENUMPUKAN",
        "AIRPORT CONSTRIBUTION",
        "TPS PROCESSING CHARGE",
        "DOCUMENT",
        "HOUSE SURCHARGE",
        "PJKP2U",
        "TRM CGO HANDLING",
    ],
    RAYA: [
        "RAYA",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor",
        "Charges",
        "Materai",
        "OB CLEARANCE",
        "TRUCKING OB",
        "STRIPPING",
        "LOLO",
        "ADMINISTRASI",
        "RDM Cargo Normal",
        "Storage Normal Masa 1.1",
        "Storage Normal Masa 1.2",
        "Storage Normal Masa 2",
        "Administrasi",
        "Surveyor",
        "Storage Terminal / hr ke 2",
        "Storage Terminal / hr ke 3 dst",
        "Lift On UTPK",
        "Pass Truck",
        "Storage OB MASA l",
        "Storage OB MASA ll",
        "Lift Off OB",
        "Lift On Delivery",
        "Paket PLP",
        "Behandle",
        "TERMINAL CHARGES",
    ],
    PRJP: [
        "PRJP",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor",
        "Charges",
        "Materai",
        "DELIVERY",
        "MECHANIC CHARGE",
        "SURVEYOR",
        "CARGO SHIFTING",
        "SURCHARGES",
        "RECOVERY CHARGES",
        "Cargo Storage 1",
        "Cargo Storage 2",
        "Cargo Storage 3",
        "Administration",
        "PENUMPUKAN JICT",
        "PENUMPUKAN TPS",
        "Lift On Terminal 40FULL",
        "Lift On/Off TPS 40FULL",
        "PAKET PLP 40 FULL",
        "Lift On Terminal",
        "Lift On/Off",
        "Paket PLP",
        "Administrasi",
    ],
    BAND: [
        "BAND",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor",
        "Charges",
        "Materai",
        "TERMINAL STORAGE PHASE 2",
        "TERMINAL STORAGE PHASE 3",
        "STORAGE PHASE 2",
        "STORAGE PHASE 3",
        "Lift Off Full",
        "Adm OB dan Perawatan IT",
        "Lift On Full",
        "Lift On Full Terminal",
        "Paket OB",
        "Pass Gate",
        "Pass Truck",
        "Pass Pelabuhan",
        "Recovery Cost",
        "Administration",
        "PENUMPUKAN MASA 1.2",
        "PENUMPUKAN MASA 2",
        "LIFT ON",
        "BIAYA PENALTI MASA SPPB",
        "LIFT OFF",
        "PAKET PLP",
        "BIAYA KEBERSIHAN",
        "Pd Tumpuk-CCC/D PK",
        "Pd Pas Kndran-Harian",
        "Pd Fee For Services",
    ],
    MTI1: [
        "MTI1",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor",
        "Charges",
        "Materai",
        "MASA BEBAS JICT",
        "STORAGE JICT PHASE 1",
        "STORAGE JICT PHASE 2",
        "STORAGE TPS PHASE 2",
        "LIFT ON JICT",
        "LIFT ON TPS",
        "LIFT OFF TPS",
        "PAKET PLP",
        "ADMINISTRASI",
        "STORAGE TPS PHASE 3",
    ],
    WIRA: [
        "WIRA",
        "TERMINAL CHARGE :",
        "Terminal Charge",
        "DETAIL OF CHARGE :",
        "Nomor DO",
        "DO Charges",
        "Materai",
        "PENUMPUKAN",
        "LIFT ON Terminal",
        "LIFT ON/OFF",
        "PAKET PLP",
        "Administrasi",
        "PAKET PELAYANAN TAMBAHAN",
    ],
};
